module.exports = __webpack_public_path__ + "img/image_23.85f649c4.png";